const queryParams = new URLSearchParams(window.location.search)
const languageParam = queryParams.get('lang')

export default function useLanguage() {
  if (languageParam === 'en_EN' || languageParam === 'fr_FR' || languageParam === 'de_DE') {
    return languageParam
  }
  if (navigator.language.startsWith('en')) {
    return 'en_EN'
  }
  return 'fr_FR'
}
